// YTD Financial data with detailed breakdowns
// Monthly data for 2025 with company and return type breakdowns

// Monthly totals (values in actual dollars)
export const monthlyFinancialData2025 = [
  {
    month: 'Jan',
    monthlyReturn: 217229,
    cumulativeReturn: 217229,
    efficiency: 180000,
    income: 12229,
    contract: 25000,
    byCompany: {
      confer: { efficiency: 125000, income: 2500, contract: 0, total: 127500 },
      cuautofi: { efficiency: 30000, income: 0, contract: 0, total: 30000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 12000, income: 0, contract: 4000, total: 16000 },
      sarisai: { efficiency: 0, income: 0, contract: 11500, total: 11500 },
      scribeup: { efficiency: 13000, income: 9729, contract: 7500, total: 30229 }
    }
  },
  {
    month: 'Feb',
    monthlyReturn: 207400,
    cumulativeReturn: 424629,
    efficiency: 172000,
    income: 11400,
    contract: 24000,
    byCompany: {
      confer: { efficiency: 120000, income: 2400, contract: 0, total: 122400 },
      cuautofi: { efficiency: 28000, income: 0, contract: 0, total: 28000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 11000, income: 0, contract: 4000, total: 15000 },
      sarisai: { efficiency: 0, income: 0, contract: 11500, total: 11500 },
      scribeup: { efficiency: 13000, income: 9000, contract: 6500, total: 28500 }
    }
  },
  {
    month: 'Mar',
    monthlyReturn: 220065,
    cumulativeReturn: 644694,
    efficiency: 182000,
    income: 13065,
    contract: 25000,
    byCompany: {
      confer: { efficiency: 130000, income: 2565, contract: 0, total: 132565 },
      cuautofi: { efficiency: 28000, income: 0, contract: 0, total: 28000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 11000, income: 0, contract: 4500, total: 15500 },
      sarisai: { efficiency: 0, income: 0, contract: 11500, total: 11500 },
      scribeup: { efficiency: 13000, income: 10500, contract: 7000, total: 30500 }
    }
  },
  {
    month: 'Apr',
    monthlyReturn: 163113,
    cumulativeReturn: 807807,
    efficiency: 135000,
    income: 10113,
    contract: 18000,
    byCompany: {
      confer: { efficiency: 95000, income: 2113, contract: 0, total: 97113 },
      cuautofi: { efficiency: 18000, income: 0, contract: 0, total: 18000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 10000, income: 0, contract: 4000, total: 14000 },
      sarisai: { efficiency: 0, income: 0, contract: 5500, total: 5500 },
      scribeup: { efficiency: 12000, income: 8000, contract: 6500, total: 26500 }
    }
  },
  {
    month: 'May',
    monthlyReturn: 173521,
    cumulativeReturn: 981328,
    efficiency: 143000,
    income: 11521,
    contract: 19000,
    byCompany: {
      confer: { efficiency: 100000, income: 2521, contract: 0, total: 102521 },
      cuautofi: { efficiency: 20000, income: 0, contract: 0, total: 20000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 10000, income: 0, contract: 4500, total: 14500 },
      sarisai: { efficiency: 0, income: 0, contract: 5500, total: 5500 },
      scribeup: { efficiency: 13000, income: 9000, contract: 7000, total: 29000 }
    }
  },
  {
    month: 'Jun',
    monthlyReturn: 196924,
    cumulativeReturn: 1178252,
    efficiency: 162000,
    income: 12924,
    contract: 22000,
    byCompany: {
      confer: { efficiency: 115000, income: 2924, contract: 0, total: 117924 },
      cuautofi: { efficiency: 22000, income: 0, contract: 0, total: 22000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 11000, income: 0, contract: 4500, total: 15500 },
      sarisai: { efficiency: 0, income: 0, contract: 8000, total: 8000 },
      scribeup: { efficiency: 14000, income: 10000, contract: 7500, total: 31500 }
    }
  },
  {
    month: 'Jul',
    monthlyReturn: 160999,
    cumulativeReturn: 1339251,
    efficiency: 130000,
    income: 10999,
    contract: 20000,
    byCompany: {
      confer: { efficiency: 90000, income: 1999, contract: 0, total: 91999 },
      cuautofi: { efficiency: 18000, income: 0, contract: 0, total: 18000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 10000, income: 0, contract: 4500, total: 14500 },
      sarisai: { efficiency: 0, income: 0, contract: 6500, total: 6500 },
      scribeup: { efficiency: 12000, income: 9000, contract: 7000, total: 28000 }
    }
  },
  {
    month: 'Aug',
    monthlyReturn: 196908,
    cumulativeReturn: 1536159,
    efficiency: 160000,
    income: 13908,
    contract: 23000,
    byCompany: {
      confer: { efficiency: 113000, income: 2908, contract: 0, total: 115908 },
      cuautofi: { efficiency: 22000, income: 0, contract: 0, total: 22000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 11000, income: 0, contract: 4500, total: 15500 },
      sarisai: { efficiency: 0, income: 0, contract: 9000, total: 9000 },
      scribeup: { efficiency: 14000, income: 11000, contract: 7500, total: 32500 }
    }
  },
  {
    month: 'Sep',
    monthlyReturn: 193898,
    cumulativeReturn: 1730057,
    efficiency: 158000,
    income: 12898,
    contract: 23000,
    byCompany: {
      confer: { efficiency: 110000, income: 2898, contract: 0, total: 112898 },
      cuautofi: { efficiency: 22000, income: 0, contract: 0, total: 22000 },
      modernfi: { efficiency: 0, income: 0, contract: 2000, total: 2000 },
      posh: { efficiency: 12000, income: 0, contract: 4500, total: 16500 },
      sarisai: { efficiency: 0, income: 0, contract: 9000, total: 9000 },
      scribeup: { efficiency: 14000, income: 10000, contract: 7500, total: 31500 }
    }
  },
  {
    month: 'Oct',
    monthlyReturn: 245227,
    cumulativeReturn: 1975284,
    efficiency: 193603,
    income: 10224,
    contract: 41400,
    byCompany: {
      confer: { efficiency: 125000, income: 2840, contract: 0, total: 127840 },
      cuautofi: { efficiency: 36369, income: 0, contract: 0, total: 36369 },
      modernfi: { efficiency: 0, income: 0, contract: 6000, total: 6000 },
      posh: { efficiency: 16000, income: 0, contract: 4416, total: 20416 },
      sarisai: { efficiency: 0, income: 0, contract: 22917, total: 22917 },
      scribeup: { efficiency: 16234, income: 7384, contract: 8067, total: 31685 }
    }
  },
  {
    month: 'Nov',
    monthlyReturn: 247411,
    cumulativeReturn: 2222695,
    efficiency: 194088,
    income: 11123,
    contract: 42200,
    byCompany: {
      confer: { efficiency: 125000, income: 3123, contract: 0, total: 128123 },
      cuautofi: { efficiency: 36369, income: 0, contract: 0, total: 36369 },
      modernfi: { efficiency: 0, income: 0, contract: 6000, total: 6000 },
      posh: { efficiency: 16160, income: 0, contract: 4417, total: 20577 },
      sarisai: { efficiency: 0, income: 0, contract: 22917, total: 22917 },
      scribeup: { efficiency: 16559, income: 8000, contract: 8866, total: 33425 }
    }
  }
];

// Company metadata for display
export const companyInfo = {
  confer: { name: 'Confer', color: '#333790' },
  cuautofi: { name: 'CUautoFi', color: '#10B981' },
  modernfi: { name: 'ModernFi', color: '#8B5CF6' },
  posh: { name: 'Posh', color: '#F59E0B' },
  sarisai: { name: 'Saris AI', color: '#EC4899' },
  scribeup: { name: 'ScribeUp', color: '#06B6D4' }
};

// Return type colors
export const returnTypeColors = {
  efficiency: '#333790',
  income: '#10B981',
  contract: '#F59E0B'
};

// Legacy format for existing charts (values in millions)
export const ytdFinancialData = monthlyFinancialData2025.map(m => ({
  month: m.month,
  monthlyReturn: m.monthlyReturn / 1000000,
  cumulativeReturn: m.cumulativeReturn / 1000000
}));

// Calculate YTD totals by company
export const calculateYTDByCompany = () => {
  const totals = {};
  const companies = Object.keys(companyInfo);

  companies.forEach(company => {
    totals[company] = { efficiency: 0, income: 0, contract: 0, total: 0 };
  });

  monthlyFinancialData2025.forEach(month => {
    companies.forEach(company => {
      if (month.byCompany[company]) {
        totals[company].efficiency += month.byCompany[company].efficiency;
        totals[company].income += month.byCompany[company].income;
        totals[company].contract += month.byCompany[company].contract;
        totals[company].total += month.byCompany[company].total;
      }
    });
  });

  return totals;
};

// Calculate YTD totals by return type
export const calculateYTDByType = () => {
  return monthlyFinancialData2025.reduce((acc, month) => ({
    efficiency: acc.efficiency + month.efficiency,
    income: acc.income + month.income,
    contract: acc.contract + month.contract,
    total: acc.total + month.monthlyReturn
  }), { efficiency: 0, income: 0, contract: 0, total: 0 });
};